module.exports = __webpack_public_path__ + "img/classrooms.ba923263.svg";